import { map } from "rxjs";
import { List } from "../../model";
import apiService from "../ApiService";

export const getList = (pageId: string, id: string, offset = 0, limit?: number) => {
  return apiService
    .get<{ list: List }>({
      path: `v2/pages/${pageId}/lists/${id}`,
      params: {
        offset: `${offset || 0}`,
        limit,
      },
    })
    .pipe(map(({ list }) => list));
};
